import { createApi } from '../client'

const api = createApi('/users')

export default api
